<div class="page page-servico" [ngClass]="{'no-padding':produtos_relacionados.length > 0}" itemscope itemtype="https://schema.org/Product">
  <div class="container-servico">
    <div class="content-body">
      <div *ngIf="response.status == 1"> 
        <div class="produto-capa" class="wow fadeIn" data-wow-delay="0.5s" *ngIf="produto.banner_ativo">   
          <produto-capa [image]="produto.banner" [nome]="produto.nome"></produto-capa>   
        </div> 
        <div class="section-breadcrumbs" *ngIf="itensBreadcrumbs.length > 0"> 
          <breadcrumbs home="false" [itens]="itensBreadcrumbs"></breadcrumbs>
        </div>
        <div class="page-content"> 
          <div class="page-title mobile-center">
            <div class="container">
              <h1 class="page-title-h1 wow slideInDown" data-wow-delay="0.5s">{{produto.nome}}</h1>
            </div>
          </div>
          <div class="container"> 
            <div class="box-content-header">
              <div class="row row-main"> 
                <div class="col-md-8" [ngClass]="{'wow fadeIn': width > 700}"  data-wow-delay="1s">
                  <div class="box box-sombra-content" *ngIf="fotos.length > 0">
                    <produto-galeria-two [photos]="fotos"></produto-galeria-two>
                  </div>
                  <div class="box box-product-info">
                    <produto-info [categoria]="categoria" [produto]="produto" [cidades]="cidades"></produto-info> 
                  </div>
                  <div class="section section-resumo">   
                    <div class="section-content">
                      <div class="box textos box-description-content" *ngIf="textos.length > 0">
                        <div class="item" *ngFor="let i of textos">
                          <h3 class="title-h3">{{i.titulo}}</h3> 
                          <article [innerHtml]="i.texto | safeHtml"></article>
                        </div>
                      </div>  
                    </div> 
                  </div>  
                  <produto-video *ngIf="produto.ativar_video" [url]="produto.link_video"></produto-video>
                  <div class="linha" *ngIf="produto.ativar_video"></div>
                  <produto-incluso [data]="caracteristicas" *ngIf="caracteristicas.length"></produto-incluso>
                  <div class="linha" *ngIf="caracteristicas.length"></div>
                  <produto-duvidas [data]="duvidas" *ngIf="duvidas.length"></produto-duvidas>
                  <produto-mapa [longitude]="produto.longitude" [latitude]="produto.latitude" *ngIf="produto.ativar_mapa"></produto-mapa>
                </div> 
                <div class="col-md-4"> 
                  <div class="box-card" [ngClass]="{'wow fadeIn': width > 700}" data-wow-delay="0.5s">
                    <div class="dm-card content-right"> 
                      <div class="content">  
                        <div class="box-sombra cart-add content-carrinho" *ngIf="!produto.vender_offline && produto.manage_id !== null">
                          <div class="item">
                            <produto-item-valor class="center" [valor]="produto.menor_tarifa" [servico]="produto" template="servico"></produto-item-valor>
                          </div>
                          <div class="item" *ngIf="dias != null || produto.duracao != null">
                            <div class="info" *ngIf="dias != null">
                              <div class="info-item">
                                <i class="fa-solid fa-calendar"></i> 
                                <span>{{dias | formatDias}}</span>
                              </div>
                            </div> 
                            <div class="info" *ngIf="produto.duracao != null">
                              <div class="info-item">
                                <i class="fa-solid fa-clock"></i>
                                <span>{{produto.duracao | formatDuracao}} / {{'duração aproximada' | translate}}</span>
                              </div>
                            </div> 
                          </div> 
                          <div class="item box-item-cart-edit" *ngIf="servicoCart !== null">
                            <dm-cart-box-edit [configuracaoLoja]="configuracao_loja" [servico]="servicoCart"></dm-cart-box-edit>
                          </div> 
                          <div class="item box-item-cart-add" *ngIf="servicoCart === null">
                            <btn-add-cart [emailSugestao]="emailSugestao" [idCart]="idCart" [email]="email" [horarios]="horarios" [servico]="produto" [categoria]="categoria" [configuracaoLoja]="configuracao_loja" [macroRegiao]="macro_regiao"></btn-add-cart>
                            <partial-compra-segura></partial-compra-segura>
                          </div> 
                        </div>  
                        <div class="box-sombra product-contact content-carrinho" *ngIf="produto.vender_offline || produto.manage_id === null">
                          <div class="item">
                            <produto-item-valor class="center" [valor]="produto.menor_tarifa" [servico]="produto" template="servico"></produto-item-valor>
                          </div>
                          <div class="item">
                            <produto-venda-offline [servico]="produto" [configuracaoLoja]="configuracao_loja"></produto-venda-offline>
                          </div>
                          <div class="item" style="border: 0 !important;">
                            <modulo posicao="whatsapp" template="servico"></modulo>
                          </div> 
                          <div class="item">
                            <modulo posicao="contato" template="telefone-servico"></modulo>
                          </div>  
                        </div>
                      </div>  
                    </div>
                  </div>
                </div>  
              </div>
            </div>
          </div> 
          <div class="section section-products section-produtos-relacionados" *ngIf="produtos_relacionados.length > 0"> 
            <div class="section-title">
              <div class="container">
                <h3>Mais experiências para a sua viagem</h3>
              </div>
            </div>    
            <div class="container">
              <produto-slider-item [data]="produtos_relacionados"></produto-slider-item>
            </div>
          </div>
      </div>  
      <div *ngIf="response.status == 500">
        <div class="container">
          <page-error [data]="response.data" (reload)="getData()"></page-error>
        </div>  
      </div>
    </div> 
  </div>
</div>    
<loader *ngIf="loader"></loader> 
  